import { z } from "zod";
import { IsoDateTime, OpaqueId } from "./common.js";
import { LineStop } from "./lines.js";
/**
 * Espace-temps (CDC §5.3/§12.1, B3.2, D-004) — le serveur renvoie des séries
 * prêtes à tracer, en (temps, distance cumulée le long de la ligne), pour que
 * le composant SVG du frontend n'ait qu'à projeter sur ses deux axes.
 */
/**
 * Fenêtres de tracé proposées au régulateur (backlog Phase 2 P2-38, demande
 * utilisateur) : `15m`, `30m` (défaut), `1h`, `2h`, `5h`, `day`. Les fenêtres
 * bornées sont centrées sur l'instant courant ; `day` = le jour d'exploitation
 * entier.
 */
export const SpacetimeWindow = z.enum(["15m", "30m", "1h", "2h", "5h", "day"]);
export const SpacetimePoint = z.object({
    t: IsoDateTime,
    distanceM: z.number(),
});
/** Segment de `realized` (par indices) sorti de la tolérance (CDC §5.3) — jamais une 3ᵉ série. */
export const SpacetimeOutOfTolerance = z.object({
    fromIndex: z.number().int().nonnegative(),
    toIndex: z.number().int().nonnegative(),
});
export const SpacetimeTrip = z.object({
    journeyId: OpaqueId,
    vehicleDisplayNumber: z.string().nullable(),
    runId: z.string().nullable(),
    /** série théorique — dérivée des horaires GTFS sur l'axe canonique. */
    scheduled: z.array(SpacetimePoint),
    /** série réalisée — dérivée de `journey_progress_samples` (fenêtre demandée uniquement). */
    realized: z.array(SpacetimePoint),
    outOfTolerance: z.array(SpacetimeOutOfTolerance),
});
export const SpacetimeResponse = z.object({
    line: OpaqueId,
    direction: z.union([z.literal(0), z.literal(1)]),
    headsign: z.string().nullable(),
    window: SpacetimeWindow,
    from: IsoDateTime,
    to: IsoDateTime,
    now: IsoDateTime,
    stopAxis: z.array(LineStop),
    trips: z.array(SpacetimeTrip),
});
//# sourceMappingURL=spacetime.js.map